import React from 'react';

interface RetroGridProps {
  children: React.ReactNode;
  className?: string;
}

export const RetroGrid: React.FC<RetroGridProps> = ({ children, className = '' }) => {
  return (
    <div className={`relative min-h-screen bg-retro-black overflow-hidden ${className}`}>
      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `
            linear-gradient(rgba(var(--color-neon-cyan-rgb), 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(var(--color-neon-cyan-rgb), 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}
      />
      
      {/* Scan line effect */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="h-full w-full bg-gradient-to-b from-transparent via-neon-cyan/5 to-transparent animate-scan" />
      </div>
      
      {/* CRT screen curve effect */}
      <div className="absolute inset-0 pointer-events-none rounded-[50px] shadow-2xl border-2 border-retro-dark/20" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};
